/**
 * "Get a Quote" links: open the parent theme's modal.
 *
 * The parent renders the CTA menu item as a plain link. Header CTAs whose
 * href is "#quote" always open the modal. Any other "#quote" link (hero
 * buttons, closing CTAs on the page patterns) opens the modal too, unless
 * the page has a #quote element to scroll to (the homepage guided form).
 */

const HEADER_CTA_SELECTOR =
	'.header-template-2__cta-link[href$="#quote"], .header-template-2__mobile-cta-link[href$="#quote"]';
const CTA_SELECTOR = `${ HEADER_CTA_SELECTOR }, a[href$="#quote"]`;

function openQuoteModal( trigger ) {
	document.dispatchEvent(
		new CustomEvent( 'modal-contact-form', {
			bubbles: true,
			detail: {
				formId: trigger.dataset.formId ? Number( trigger.dataset.formId ) : null,
				title: trigger.dataset.modalTitle || trigger.textContent.trim(),
				description: trigger.dataset.modalDescription || '',
				triggerElement: trigger,
			},
		} )
	);
}

export default function initHeaderCta() {
	document.addEventListener( 'click', ( event ) => {
		if ( ! ( event.target instanceof Element ) ) {
			return;
		}
		const trigger = event.target.closest( CTA_SELECTOR );
		if ( ! trigger ) {
			return;
		}
		if ( ! trigger.matches( HEADER_CTA_SELECTOR ) ) {
			const sameDocument =
				trigger.origin === window.location.origin &&
				trigger.pathname === window.location.pathname;
			if ( ! sameDocument || document.getElementById( 'quote' ) ) {
				return;
			}
		}
		event.preventDefault();
		openQuoteModal( trigger );
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initHeaderCta );
} else {
	initHeaderCta();
}
